import { render, staticRenderFns } from "./documentation.vue?vue&type=template&id=9ac2fe78&scoped=true"
import script from "./documentation.vue?vue&type=script&lang=js"
export * from "./documentation.vue?vue&type=script&lang=js"
import style0 from "./documentation.vue?vue&type=style&index=0&id=9ac2fe78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac2fe78",
  null
  
)

export default component.exports